module.exports = __webpack_public_path__ + "static/media/Figtree-Light.014df848.ttf";